export default "__VITE_ASSET__4fada301__"